import axios from 'axios/index';
import React, {PureComponent} from 'react';

import {Classes, Overlay} from "@blueprintjs/core";
import toastr from 'toastr';
import {getCurrentUserId, getJwt} from '../../services/authService';
import http from '../../services/httpService';

export default class ViberModal extends PureComponent {
    state = {
        overlayIsOpen: false,
        viberEnableRequests: ''
    }
    handleClose = () => {
        this.setState({
            overlayIsOpen: false
        })
    }
    redirectToForm = () => {
        window.open('https://emitto.io/viber-new-sender-name/')
    }
    requestViberEnable = async (e) => {
        //const data = this.state.data;
        // const user_id = await getCurrentUserId();
        // const user = await http.get('api/user/' + user_id, { headers: { authorization: getJwt() } });
        const user = await http.get('api/user_info', {headers: {authorization: getJwt()}});

        const sources = this.props.sources;
        // const feeds_shared = this.props.feeds_shared;
        const index = sources.findIndex((src) => src.id.toString() === this.props.selectedSource);
        // const index2 = feeds_shared ? feeds_shared.findIndex((src2) => src2.project_id.toString() === this.props.selectedSource) : -1;

        let sourceData = index !== -1 ?
            sources[index]
            //: index2 !== -1 ? feeds_shared[index2]
            : '';

        let name = user.data.data.name;
        let id = user.data.data.id;
        // console.log('user name: ', name);

        let message = 'User ' + name + ' (id: ' + id + '), wants to enable Viber for workspace ' + sourceData.name + ' (id: ' + this.props.selectedSource + ').';
        // console.log('message: ', message);

        let email = user.data.data.email;
        // console.log(email);
        // await localStorage.removeItem("viberEnableRequests");
        let viberEnableRequestsData = await localStorage.getItem("viberEnableRequests");
        let dataParsed = JSON.parse(viberEnableRequestsData)
        if (dataParsed) {
            await dataParsed.push(this.props.selectedSource)
        } else {
            dataParsed = await [this.props.selectedSource]
        }

        try {
            axios.post('/support-mail', {
                "message": message,
                "email": email,
                "name": name,
                "title": 'Viber Request',
                "subject": 'app.emitto support >> ' + name + ' >> Enable Viber'
            })
                .then(res => {
                    // console.log(res);
                    // console.log(res.data);
                    toastr.info('Our team will get back to you in the next 48 hours. Make sure to check your e-mail! ');
                    localStorage.setItem("viberEnableRequests", JSON.stringify(dataParsed));
                    this.setState({
                        viberEnableRequests: dataParsed
                    })
                    this.props.setViberCheck(this.props.selectedSource)
                });
        } catch (ex) {
            toastr.error('Something went wrong, please try again.');
        }

    };

    componentDidMount() {
        this.setState({
            overlayIsOpen: this.props.showModal,
        })
    }

    componentDidUpdate() {
        if (this.state.overlayIsOpen !== this.props.showModal) {
            this.setState({
                overlayIsOpen: this.props.showModal
            })
        }
    }

    render() {
        return (
            <Overlay
                onClose={this.props.handleClose} className={Classes.OVERLAY_SCROLL_CONTAINER}
                isOpen={this.state.overlayIsOpen}
                style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div className="modal-field"
                     style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>
                    <p className="modal-close-button" onClick={() => {
                        this.props.handleClose()
                    }}><i className="fas fa-times"></i></p>
                    <div className="onboarding-panel">
                        <h1 className="m-m-b"><i style={{color: '#665cac'}} className="fab fa-viber"></i> Enable Viber
                        </h1>
                        <div className="separator"></div>
                        <div className="form-group m-m-b">

                            <span>Setting up Viber is still a partially manual process. We're
                                happy to assist you and get you set up. Click on <strong>'I'm interested'</strong> button
                                bellow and someone from our support team will reach out to you.
                            </span>
                        </div>
                        <div className="separator m-m-b"></div>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <button
                                disabled={false}
                                onClick={() => {
                                    this.redirectToForm()
                                    this.props.handleClose()
                                }}
                                name="cancel_delete_tag"
                                id="cancel_delete_tag"
                                type="button"
                                className='btn-action btn-sm m-sm-b center'>I'm interested
                            </button>
                        </div>
                    </div>
                </div>
            </Overlay>
        )
    }
}